import { ThumbtackPro } from './../api/adserver/index';
import { NativeModules } from 'react-native';

import { AnalyticsAPI } from '../zonetail-explore-library';

import { Advertisement, Gallery } from '../api/adserver';
import { NewsItem } from '../api/adserver';
import analytics from '../lib/wrapAnalytics';

const debug = require('debug')('se:analytics');

function getAPI(): AnalyticsAPI {
  return analytics;
}

function trackAdvertAction(
  action: string,
  advertName: string,
  advertCategory: string,
  id: string,
  advertCategoryId: string,
) {
  setTimeout(() => {
    debug(`track advert action: ${action}, for advert:${advertName}`);
    const analyticsAPI = getAPI();
    if (NativeModules.RNAction && NativeModules.RNAction.trackAdvertAction) {
      NativeModules.RNAction.trackAdvertAction(
        action,
        advertName,
        advertCategory,
        id,
        advertCategoryId,
      );
    } else if (analyticsAPI.trackAdvertAction) {
      analyticsAPI.trackAdvertAction(
        action,
        advertName,
        advertCategory,
        id,
        advertCategoryId,
      );
    } else {
      console.warn(
        'no NativeModules.RNAction.trackAdvertAction and no analytics api',
      );
    }
  }, 10);
}

function trackAdvertCategory(category: string, id: string) {
  setTimeout(() => {
    const analyticsAPI = getAPI();
    if (NativeModules.RNAction && NativeModules.RNAction.trackAdvertCategory) {
      NativeModules.RNAction.trackAdvertCategory(category, id);
    } else if (analyticsAPI.trackAdvertCategory) {
      analyticsAPI.trackAdvertCategory(category, id);
    } else {
      console.warn(
        'no NativeModules.RNAction.trackAdvertCategory and no analytics api',
      );
    }
  }, 10);
}

function trackAdvertView(advert: Advertisement) {
  setTimeout(() => {
    if (!advert.campaign) {
      return;
    }
    const analyticsAPI = getAPI();
    const advertiserId = advert.advertiser.id.toString();
    const advertiserName = advert.advertiser.name;
    const categoryName = advert.categories[0].title;
    const categoryId = advert.categories[0].id.toString();
    const campaignName = advert.campaign?.name;
    const campaignId = advert.campaign?.id.toString();
    const name = advert.headline;
    const id = advert.id.toString();
    // debug(`track advert view: ${advert.headline}`);
    if (NativeModules.RNAction && NativeModules.RNAction.trackAdvertView) {
      NativeModules.RNAction.trackAdvertView(
        id,
        name,
        categoryId,
        categoryName,
        advertiserId,
        advertiserName,
        campaignId,
        campaignName,
      );
    } else if (analyticsAPI.trackAdvertView) {
      // @ts-ignore
      analyticsAPI.trackAdvertView(advert);
    } else {
      console.warn(
        'no NativeModules.RNAction.trackAdvertView and no analytics api',
      );
    }
  }, 10);
}

function trackAdvertDetailView(advert: Advertisement) {
  setTimeout(() => {
    if (!advert.campaign) {
      return;
    }
    const analyticsAPI = getAPI();
    const advertiserId = advert.advertiser.id.toString();
    const advertiserName = advert.advertiser.name;
    const categoryName = advert.categories[0].title;
    const categoryId = advert.categories[0].id.toString();
    const campaignName = advert.campaign?.name;
    const campaignId = advert.campaign?.id.toString();
    const name = advert.headline;
    const id = advert.id.toString();
    debug(`track advert details view: ${advert.headline}`);
    if (
      NativeModules.RNAction &&
      NativeModules.RNAction.trackAdvertDetailView
    ) {
      NativeModules.RNAction.trackAdvertDetailView(
        id,
        name,
        categoryId,
        categoryName,
        advertiserId,
        advertiserName,
        campaignId,
        campaignName,
      );
    } else if (analyticsAPI.trackAdvertDetailView) {
      analyticsAPI.trackAdvertDetailView(
        id,
        name,
        categoryId,
        categoryName,
        advertiserId,
        advertiserName,
        campaignId,
        campaignName,
      );
    } else {
      console.warn(
        'no NativeModules.RNAction.trackAdvertDetailView and no analytics api',
      );
    }
  }, 10);
}

function trackThumbtackDetailView(advert: ThumbtackPro, context: any) {
  setTimeout(() => {
    if (!context || !context.category) {
      debug(
        `no thumbtack detail category. "${advert.business_name}" cannot log analytics.`,
      );
      return;
    }
    const analyticsAPI = getAPI();
    const advertiserId = 'thumbtack';
    const advertiserName = 'thumbtack';
    const categoryName = `thumbtack_${context.category.title}`;
    const categoryId = context.category.title;
    const campaignName = advert.thumbtack_url;
    const campaignId = advert.thumbtack_url;
    const name = advert.business_name;
    const id = advert.id.toString();
    debug(`track thumbtack details view: ${advert.business_name}`);
    if (
      NativeModules.RNAction &&
      NativeModules.RNAction.trackServiceDetailView
    ) {
      NativeModules.RNAction.trackServiceDetailView(
        id,
        name,
        categoryId,
        categoryName,
        advertiserId,
        advertiserName,
        campaignId,
        campaignName,
      );
    } else if (analyticsAPI.trackServiceDetailView) {
      analyticsAPI.trackServiceDetailView(
        id,
        name,
        categoryId,
        categoryName,
        advertiserId,
        advertiserName,
        campaignId,
        campaignName,
        'thumbtack',
      );
    } else {
      console.warn(
        'no NativeModules.RNAction.trackServiceDetailView and no analytics api',
      );
    }
  }, 10);
}

function trackAdvertCategoryAction(
  category: string,
  categoryId: string,
  advertName: string,
  advertId: string,
  action: string,
) {
  setTimeout(() => {
    const analyticsAPI = getAPI();
    if (
      NativeModules.RNAction &&
      NativeModules.RNAction.trackAdvertCategoryAction
    ) {
      NativeModules.RNAction.trackAdvertCategoryAction(
        category,
        categoryId,
        advertName,
        advertId,
        action,
      );
    } else if (analyticsAPI.trackAdvertCategoryAction) {
      analyticsAPI.trackAdvertCategoryAction(
        category,
        categoryId,
        advertName,
        advertId,
        action,
      );
    } else {
      console.warn(
        'no NativeModules.RNAction.trackAdvertCategoryAction and no analytics api',
      );
    }
  }, 10);
}

function trackScreenView(screenName: string) {
  setTimeout(() => {
    const analyticsAPI = getAPI();
    if (NativeModules.RNAction && NativeModules.RNAction.trackScreenView) {
      NativeModules.RNAction.trackScreenView(screenName);
    } else if (analyticsAPI.trackScreenView) {
      analyticsAPI.trackScreenView(screenName);
    } else {
      console.warn(
        'no NativeModules.RNAction.trackScreenView and no analytics api',
      );
    }
  }, 10);
}

function trackSearch(screenName: string) {
  // set timeout after submission and don't send again until after timeout.
  // updates override existing buffer
  setTimeout(() => {
    const analyticsAPI = getAPI();
    if (NativeModules.RNAction && NativeModules.RNAction.trackScreenView) {
      NativeModules.RNAction.trackScreenView(screenName);
    } else if (analyticsAPI.trackSearch) {
      analyticsAPI.trackSearch(screenName);
    } else {
      console.warn(
        'no NativeModules.RNAction.trackSearch and no analytics api',
      );
    }
  }, 10);
}

function trackNewsDetailView(news: NewsItem) {
  setTimeout(() => {
    if (!news) {
      return;
    }
    const analyticsAPI = getAPI();
    const newsId = news.id.toString();
    const newsName = news.title;
    debug(`track news details view: ${news.title}`);
    if (NativeModules.RNAction && NativeModules.RNAction.trackNewsDetailView) {
      NativeModules.RNAction.trackNewsDetailView(newsId, newsName);
    } else if (analyticsAPI.trackNewsDetailView) {
      analyticsAPI.trackNewsDetailView(newsId, newsName);
    } else {
      console.warn('no NativeModules.RNAction.news and no analytics api');
    }
  }, 10);
}

function trackGalleryView(gallery: Gallery) {
  setTimeout(() => {
    if (!gallery) {
      return;
    }
    const analyticsAPI = getAPI();
    const galleryId = gallery.id.toString();
    const galleryTitle = gallery.title;
    debug(`track gallery details view: ${gallery.title}`);
    if (NativeModules.RNAction && NativeModules.RNAction.trackGalleryView) {
      NativeModules.RNAction.trackGalleryView(galleryId, galleryTitle);
    } else if (analyticsAPI.trackGalleryView) {
      analyticsAPI.trackGalleryView(galleryId, galleryTitle);
    } else {
      console.warn(
        'no NativeModules.RNAction.trackGalleryView and no analytics api',
      );
    }
  }, 10);
}

function trackContestView(contest: any) {
  setTimeout(() => {
    try {
      if (!contest) {
        return;
      }
      const analyticsAPI = getAPI();
      const contestId = contest.id.toString();
      const contestTitle = contest.title;
      debug(`track contest details view: ${contest.title}`);
      if (analyticsAPI.trackContestView) {
        analyticsAPI.trackContestView(contestId, contestTitle);
      } else {
        console.warn(
          'no NativeModules.RNAction.trackGalleryView and no analytics api',
        );
      }
    } catch (e) {
      console.log('error with track contest', e);
    }
  }, 10);
}

function trackContactUsView() {
  setTimeout(() => {
    try {
      const analyticsAPI = getAPI();
      if (analyticsAPI.trackScreenView) {
        analyticsAPI.trackScreenView('contactUs');
      } else {
        console.warn(
          'no NativeModules.RNAction.trackContactUsView and no analytics api',
        );
      }
    } catch (e) {
      console.log('error with track contest', e);
    }
  }, 10);
}

export {
  trackAdvertAction,
  trackAdvertCategory,
  trackAdvertCategoryAction,
  trackAdvertDetailView,
  trackThumbtackDetailView,
  trackAdvertView,
  trackContactUsView,
  trackContestView,
  trackGalleryView,
  trackNewsDetailView,
  trackScreenView,
  trackSearch,
};
